import { render, staticRenderFns } from "./RCheckbox.vue?vue&type=template&id=ecf48ea8&scoped=true"
import script from "./RCheckbox.vue?vue&type=script&lang=js"
export * from "./RCheckbox.vue?vue&type=script&lang=js"
import style0 from "./RCheckbox.vue?vue&type=style&index=0&id=ecf48ea8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecf48ea8",
  null
  
)

export default component.exports